import React from "react"
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { selectTeamMacroLeadTags } from "../../slices/teamAndUserSettingsSlice";
import {
  AnalysisPanel,
  CategoryLabel,
  CategoryRow,
  DataCell,
  FieldPill,
  HeaderCell,
  PanelIntro,
  StatusIconCell,
  TableHeaderRow,
  TableRow,
  TableShell,
  TableViewport,
} from "./ConfigurationTableLayout";

const displayParameterLabel = (label) => (
  label.includes('Primary') ?
    label.replace('Primary', '').toUpperCase()
  : label.includes('Secondary') ?
    label.replace('Secondary', '').toUpperCase()
  :
    label.toUpperCase()
)

const ParameterTags = ({ mortgageDataModel }) => {
  const theme = useTheme()

  const teamMacroLeadTags = useSelector(selectTeamMacroLeadTags)
  const tagColumns = `minmax(17rem, 1.5fr) repeat(${teamMacroLeadTags.length}, minmax(7.5rem, 0.8fr))`

  return (
    <AnalysisPanel>
      <PanelIntro>
        <span>This table displays the breakdown of which tags are applied when discrepancies are found in each respective field.</span>
        <span>Contact you App Administrator to propose new tags.</span>
      </PanelIntro>
      <TableShell>
        <TableViewport>
          <TableHeaderRow style={{gridTemplateColumns: tagColumns}}>
            <HeaderCell>label</HeaderCell>
            {teamMacroLeadTags.map((tag) => (
              <HeaderCell key={tag.label} $center>
                {tag.label}  
              </HeaderCell>
            ))}
          </TableHeaderRow>
          {mortgageDataModel.map((category, index) => (index !== 0 &&
            <div key={category.subCat}>
              <CategoryRow style={{gridTemplateColumns: tagColumns}}>
                <CategoryLabel>{category.subCat}</CategoryLabel>
              </CategoryRow>
              {category.fields.map((sweepParameter, index) => (
                <TableRow
                  key={sweepParameter.label}
                  $even={index%2 === 1}
                  style={{gridTemplateColumns: tagColumns}}
                >
                  <DataCell>
                    <FieldPill $tier={sweepParameter.assignedTier}>
                      {displayParameterLabel(sweepParameter.label)}
                    </FieldPill>
                  </DataCell>
                  {teamMacroLeadTags.map((leadTag, tagIndex) => (
                    sweepParameter.tags.includes(leadTag.apiMapping)  ?
                      <StatusIconCell $center key={tagIndex}>
                        <RadioButtonCheckedIcon style={{color: `${theme.palette.primary.main}`}} />
                      </StatusIconCell>
                    :
                      <StatusIconCell $center key={tagIndex}>
                        <RadioButtonUncheckedIcon style={{color: `${theme.palette.common.grayBorderMedium}`}} />
                      </StatusIconCell>
                  ))}
                </TableRow>
              ))}
            </div>
          ))}
        </TableViewport>
      </TableShell>
    </AnalysisPanel>
  )
}

export default ParameterTags;
